var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { directives: [{ name: "loading", rawName: "v-loading", value: !_vm.isEstablished, expression: "!isEstablished" }], staticClass: "ts-player" }, [_c('canvas', { ref: "ts", style: _vm.canvasStyle }), _vm._v(" "), _vm.isEstablished ? _c('div', { staticClass: "toggle-button", on: { "click": _vm.toggle } }, [_vm.isPause ? _c('i', { staticClass: "el-icon-video-play" }) : _c('i', { staticClass: "el-icon-video-pause" })]) : _vm._e()]);
};
var staticRenderFns = [];

export { render, staticRenderFns };